import { useTranslation } from 'react-i18next';

import { Typography } from '@/components/Typography';

/** Pied de page : mentions légales. */
export const Footer = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <footer className='flex flex-wrap items-center gap-2 px-4 py-3'>
      <Typography variant='paragraphMini' data-testid='footer-legal'>
        © {currentYear} Actual Group · {t('footer.company.legal_notice')} · {t('footer.development')}
      </Typography>
    </footer>
  );
};
